export default {
    computed :{
        $isCategoryPage () {
            return this.$route.path === '/shop/categories'
        }
    }
}
